import React from 'react'
import AsyncSelect from 'react-select/async'

const customStyles = {
    option: (provided: any, state: any) => ({
        ...provided,
        backgroundColor: state.isDisabled
            ? undefined
            : state.isSelected
            ? '#1280bb'
            : state.isFocused
            ? '#81cdf5'
            : undefined,
        color: !state.isDisabled
            ? state.isSelected
                ? '#fff'
                : state.isFocused
                ? '#565656'
                : '#565656'
            : undefined,
        ':active': {
            ...provided[':active'],
            backgroundColor: state.isDisabled
                ? undefined
                : state.isSelected
                ? '#1280bb'
                : state.isFocused
                ? '#81cdf5'
                : undefined,
        },
    }),
    dropdownIndicator: (provided: any) => ({
        ...provided,
        display: 'none',
    }),
    indicatorSeparator: (provided: any) => ({
        ...provided,
        display: 'none',
    }),
    control: (provided: any) => ({
        ...provided,
        paddingTop: 1,
        borderRadius: 70,
        backgroundColor: '#fff',
        outline: '2px solid transparent',
        border: '1px solid #BBBBBB',
        boxShadow: '0 0 0 0 #215b33',
        ':hover': {
            ...provided[':active'],
            borderColor: '#BBBBBB',
            backgroundColor: '#FFFFFF !important',
        },
        ':active': {
            ...provided[':active'],
            borderColor: '#BBBBBB',
            backgroundColor: '#FFFFFF !important',
        },
    }),
}

const SelectFilterAsync = (properties: {
    isMulti?: boolean
    selected: any
    onChange: (item: any) => void
    loadOptions: any
    placeholder: string
}) => {
    return (
        <AsyncSelect
            cacheOptions
            defaultOptions
            styles={customStyles}
            value={properties.selected}
            isMulti={properties.isMulti}
            onChange={properties.onChange}
            loadOptions={properties.loadOptions}
            placeholder={properties.placeholder || 'Buscar'}
            noOptionsMessage={() => 'No se encontraron resultados'}
        />
    )
}

export default SelectFilterAsync
